import React from 'react'
import styles from './style/visit_section_style.module.scss'
import Typography from '../../design-system/foundations/typography/Typography'
import Foundation from '../../design-system/foundations/Foundation'
import Button from '../../design-system/basics/button/Button'
import Translation from '../../global/Translation'
import { withRouter } from 'react-router-dom'

const Visit = (props) => {

    return (
        <div className={styles['visit']}>

            <Foundation back-accent-100>

                <div className={styles['visit-text-container']}>
                    <Typography className={styles['visit-title']} typeface="title-xl-light">
                        <Translation id="book_visit_online_to_warehouse" defaultMessage="BOOK YOUR VISIT ONLINE TO THE NATURAL STONE WAREHOUSE"/>
                    </Typography>

                    <Typography className={styles['visit-desc']} typeface="title-m-medium">
                        <Translation id="find_unique_designs"
                                     defaultMessage="Find unique designs for your projects with the help of a specialist."
                        />
                    </Typography>

                    <div className={styles['visit-enumeration']}>
                        <Typography className={styles['visit-enumeration-index']} typeface="title-l-regular">
                            1
                        </Typography>
                        <Typography className={styles['visit-enumeration-desc']} typeface="title-m-light">
                            <Translation id="request_visit_online_desc"
                                         defaultMessage="Request your visit online, indicating your interests and preferences."
                            />
                        </Typography>
                    </div>

                    <div className={styles['visit-enumeration']}>
                        <Typography className={styles['visit-enumeration-index']} typeface="title-l-regular">
                            2
                        </Typography>
                        <Typography className={styles['visit-enumeration-desc']} typeface="title-m-light">
                            <Translation id="select_preferred_date"
                                         defaultMessage="Select your preferred date and time."
                            />
                        </Typography>
                    </div>

                    <div className={styles['visit-enumeration']}>
                        <Typography className={styles['visit-enumeration-index']} typeface="title-l-regular">
                            3
                        </Typography>
                        <Typography className={styles['visit-enumeration-desc']} typeface="title-m-light">
                            <Translation id="explore_unique_designs"
                                         defaultMessage="Explore our unique designs and select with the support of an expert."
                            />
                        </Typography>
                    </div>

                    <div className={styles['visit-button']}>
                        <Button style-white
                                size-l
                                onClick={() => window.open(props.url)}
                                img="arrow_short"
                                hImg="arrow_large"
                                gtmLabel="footer_button_go-to-book-online-visit"
                        >
                            <Translation id="book_online_visit"
                                         defaultMessage="Book online visit"
                            />
                        </Button>
                    </div>
                </div>
            </Foundation>

            <div className={styles['visit-image-container']}>
                <img
                    src="https://static.cosentino.com/ImagesCommunityCosentinoWe/mainServices/virtualVisit_PN.png"
                    className={styles['visit-image']}
                    width='100%'
                />
            </div>


        </div>
    )
};

export default withRouter(Visit);